import { render, staticRenderFns } from "./HistoryLoader.vue?vue&type=template&id=fd13ae6e"
import script from "./HistoryLoader.vue?vue&type=script&lang=ts"
export * from "./HistoryLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports